<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Post Transplant Details EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <!-- <div class="row">
        <div class="col-4">
          Date of Entry  :
        </div> <div class="col-4">
          <input
            v-model="tglnId"
            class="inputDisplay"
            disabled
          >
        </div>
      </div> -->
    
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="recipientStatus"
              disabled
              label="Recipient Status"
              class="mandatory-field recipientStatus"
            />
          </div>

          <div class="col-2" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft' || recipientStatus?.toLowerCase() === 'graft failure'">
            <ADSTextInput
              v-model="sourceOfInformation"
              disabled
              label="Source of Information"
            />
          </div>
        </div>

        <div class="row" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'">
          <div class="col-3">
            <ADSTextInput
              v-model="dateClinicVisit"
              disabled
              label="Date of Clinic Visit or Contact with Source"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft' && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="returnedToChronicDialysis"
              disabled
              label="Returned to Chronic Dialysis"
            />
          </div>
          <div class="col-2" v-if="recipientStatus?.toLowerCase() === 'graft failure'">
            <ADSTextInput
              v-model="failureDate"
              disabled
              label="Failure Date"
            />
          </div>

          <div class="col-2" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
            />
          </div>

          <div class="col-2" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="serumCreatinineDate"
              disabled
              label="Serum Creatinine Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2" v-if="recipientStatus?.toLowerCase() === 'graft failure'">
            <ADSTextInput
              v-model="failureCause"
              disabled
              label="Failure Cause"
            />
          </div>

          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="dateReturnedToChronicDialysis"
              disabled
              label="Date Returned to Chronic Dialysis"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2" v-if="failureCause?.toLowerCase() === 'other'">
            <ADSTextInput
              v-model="failureCauseOther"
              disabled
              label="Failure Cause - Other"
            />
          </div>

          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'lost to follow-up'">
            <ADSTextInput
              v-model="lostFollowUpReason"
              disabled
              label="Lost to Follow-Up Reason"
              class="lostFollowUpReason"
            />
          </div>


          <div class="col-2" v-if="recipientStatus?.toLowerCase() === 'recipient death'">
            <ADSTextInput
              v-model="deathDate"
              disabled
              label="Death Date"
            />
          </div>
        </div>

        <div class="row" v-if="recipientStatus?.toLowerCase() === 'recipient death'">
          <div class="col-2">
            <ADSTextInput
              v-model="causeDeathCategory"
              disabled
              label="Cause of Death Category"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="causeDeathType"
              disabled
              label="Cause of Death Type"
            />
          </div>
        </div>

        <div class="row" v-if="recipientStatus?.toLowerCase() === 'recipient death'">
          <div class="col-2">
            <ADSTextInput
              v-model="causeDeathTypeOther"
              disabled
              label="Cause of Death Type Other"
            />
          </div>
  
          <div class="col-2">
            <ADSTextInput
              v-model="graftFunctioning"
              disabled
              label="Graft Functioning at Death"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "PostTransplantPancreasSectionDetailsEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      recipientStatus: this.getRecipientStatus( this.patientBundle ),
      sourceOfInformation: this.getSourceOfInfo( this.patientBundle ),
      dateClinicVisit: this.getDateClinicVisit( this.patientBundle ),
      returnedToChronicDialysis: this.getReturnedToChronicDialysis( this.patientBundle ),
      dateReturnedToChronicDialysis: this.getDateReturnedToChronicDialysis( this.patientBundle ),
      failureDate: this.getFailureDate( this.patientBundle ),
      failureCause: this.getFailureCause( this.patientBundle ),
      failureCauseOther: this.getFailureCauseOther( this.patientBundle ),
      lostFollowUpReason: this.getLostFollowUpReason( this.patientBundle ),
      deathDate: this.getDeathDate( this.patientBundle ),
      causeDeathCategory: this.getCauseDeathCategory( this.patientBundle ),
      causeDeathType: this.getCauseDeathType( this.patientBundle ),
      serumCreatinine: this.getSerumCreatinine( this.patientBundle )?.toString(),
      serumCreatinineDate: this.getSerumCreatinineDate( this.patientBundle )?.substring( 0,10 ),
      causeDeathTypeOther: this.getCauseDeathTypeOther( this.patientBundle ),
      graftFunctioning: this.getGraftFunctioning( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getRecipientStatus( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4123' );
    },
    getSourceOfInfo( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3774' );
    },
    getSerumCreatinine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4027' );
    },
    getSerumCreatinineDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4028', 'valueDateTime' );
    },
    getDateClinicVisit( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4124', 'valueDateTime' );
    },
    getReturnedToChronicDialysis( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4030' );  
    },
    getDateReturnedToChronicDialysis( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4031', 'valueDateTime' );
    },
    getFailureDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4126', 'valueDateTime' );
    },
    getFailureCause( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4127' );
    },
    getFailureCauseOther( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4128', );
    },
    getLostFollowUpReason( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4129', );
    },
    getDeathDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4130', 'valueDateTime' );
    },
    getCauseDeathCategory( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4131', );
    },
    getCauseDeathType( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4132', );
    },
    getCauseDeathTypeOther( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3832', );
    },
    getGraftFunctioning( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4125', );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 740px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 740px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
width: 320px;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.comments .afflo-ds-form-control) {
  width: 330px;
}

:deep(.recipientStatus .afflo-ds-form-control) {
  width: 330px;
}

:deep(.lostFollowUpReason .afflo-ds-form-control) {
  width: 330px;
}

:deep(.mandatory-field label::after) {
  content: " *";
  color: red;
}

</style>
